import IntegrationTable from "@/components/shared/IntegrationTable/IntegrationTable";
import MundAppSell from "../icons/MundAppSell";
import AppSellIcon from "../icons/AppSell";
import { integrationFieldPresets } from "@/components/shared/IntegrationTable/integrationFieldPresets";
import { t } from "i18next";
import { useAuth } from "@/auth/Auth";

export default function AppSell() {
  const { authData } = useAuth();

  return (
    <IntegrationTable
      integrationKey="app_sell"
      title="App Sell"
      main_icon={<MundAppSell />}
      icon={<AppSellIcon />}
      fields={[
        integrationFieldPresets.access_token,
        integrationFieldPresets.status,
      ]}
      fixedValues={{
        payment_methods: authData?.available_payment_methods?.map(m => m.type) || [],
        active_statuses: ["paid", "refunded"],
        // TO DO - ChangeBack in active_statuses
      }}
      fieldLabels={{
        access_token: "Token",
        placeholder_access_token: t("sales:access_token"),
      }}
    />
  );
}
